import { writable } from "svelte/store";
import { PageTheme } from "../gql/genCms/codegen";

export const navTheme = writable(PageTheme.Dark);
